import { selectTenantId } from "../../../../util/store/selectors";
import { getStore } from "../../../../util/store/store";
import { ACTION_TYPE, KEY_STORAGE, OPERATION_TYPE, SITE_TYPE, VIEW_SMOOTH } from "../../../../util/varibles/constants";
import { getElById, uuid } from "../../../../util/varibles/global";
import { IActivityLog, TCrewTask, IVessel, TOperation } from "../../../../util/varibles/interface";
import { checkOperationType } from "../../BiologyBrowser/constants";
import { FuncOp } from "./constants";

interface IUncheckBiology {
    uncheck?(): void
}

interface IBeginCreate {
    vessel: IVessel
    availableTimeId: string
    contractId: string
    startTime: number
    defaultOpType: any
    operation?: Partial<TOperation>
}

export const funcGlobal = {
    [FuncOp.UncheckBiology]: (args: any | IUncheckBiology) => {
        localStorage.setItem(KEY_STORAGE.CLEAR_CHECK_BIOLOGY, Date.now().toString());
        if (args.uncheck)
            args.uncheck();
        localStorage.removeItem(KEY_STORAGE.UNITS_SELECTED);
        return {}
    },

    [FuncOp.BeginCreate]: (args: any | IBeginCreate) => {
        const { vessel, availableTimeId, contractId, startTime, defaultOpType, operation } = args;
        const unitsNew = JSON.parse(localStorage.getItem(KEY_STORAGE.UNITS_SELECTED) || '{}');
        const requestType = JSON.parse(localStorage.getItem(KEY_STORAGE.REQUIRE_OPERATION_TYPE) || '[]');
        const limitOperationTypes = checkOperationType(vessel, requestType);

        if (limitOperationTypes.length === 0)
            return {};

        let isInternal = false;

        const { store, total_weight, sub_operations } = Object.keys(unitsNew).reduce((data: any, key: string) => {
            const { total_weight, harvest_id = '-', site_type } = unitsNew[key];
            if (!isInternal) {
                isInternal = site_type === SITE_TYPE.INTERNAL
            }
            data.total_weight += total_weight;
            data.store[key] = { ...unitsNew[key], harvest_id }
            data.sub_operations.push(unitsNew[key]);
            return data;
        }, { store: {}, total_weight: 0, sub_operations: [] });

        const { [vessel.id]: veselOpType = {}, global = null } = defaultOpType || {};
        const defaultType = veselOpType.type || global;

        const operationType = limitOperationTypes.find((item: any) => item === defaultType) || limitOperationTypes[0]
        const stateGlobal = getStore();
        const id = stateGlobal.planOperation.indexId;
        const userTenantId = selectTenantId(stateGlobal);


        return {
            isShow: true,
            operationType,
            limitOperationTypes,
            isAllowChange: limitOperationTypes.length > 1,
            editMode: ACTION_TYPE.CREATE,
            isFull: limitOperationTypes[0] === OPERATION_TYPE.HARVEST,
            isInternal,
            values: {
                store,
                activity_log: [{ est_start_time: startTime }],
                operation: {
                    ...operation || {},
                    id: uuid(),
                    operation_code: id,
                    total_weight,
                    tenant_id: userTenantId,
                    sub_operations,
                    available_time_id: availableTimeId,
                    contract_id: contractId,
                },
                vessel,
            },
        }
    },
}

export function focusOp(id: string) {
    setTimeout(() => {
        const el = getElById(id);
        if (el)
            el.scrollIntoView(VIEW_SMOOTH)
    }, 300)
}

export const updateTime = (activityLog: IActivityLog[], duration: number, startTime = 0) => {
    const space = startTime ? startTime - activityLog[0].est_start_time : duration;
    return activityLog.map((item: IActivityLog) => ({ ...item, est_start_time: item.est_start_time + space }));
}

export const resolveActivityLog = (current: IActivityLog[] = [], next: IActivityLog[], durationEst?: number) => {
    const nextDuration = next[next.length - 1].est_start_time - next[0].est_start_time;
    const currentDuration = current.length > 0
        ? current[current.length - 1].est_start_time - current[0].est_start_time
        : undefined;
    const keepCurrentDuration = durationEst !== undefined && currentDuration !== undefined
        && currentDuration !== durationEst && currentDuration > nextDuration;

    return {
        activity_log: keepCurrentDuration ? next.map((item, index) => index === next.length - 1
            ? { ...item, est_start_time: next[0].est_start_time + currentDuration! }
            : item) : next,
        duration_est: nextDuration
    };
}

export const updateCrewTasksTime = (crewTasks: TCrewTask[] = [], duration: number) => {
    return crewTasks.map(task => ({
        ...task,
        ...(task.est_start_time === undefined ? {} : { est_start_time: task.est_start_time + duration }),
        ...(task.est_finish_time === undefined ? {} : { est_finish_time: task.est_finish_time + duration }),
    }));
}
